import { useCallback } from 'react';

/**
 * Hook de capa de UI para DocumentMC.
 * Encapsula la lógica de click y composición de clases.
 * No contiene lógica de datos ni de negocio.
 */
export default function useDocumentMessageUI({ className, iconClassName, url, fileName }) {
  // Memoiza la composición de clases para performance
  const getLinkClass = useCallback(() => `tw-flex tw-items-center tw-font-medium tw-text-sm hover:tw-underline ${className || ''}`, [className]);
  const getIconClass = useCallback(() => `tw-mr-1 ${iconClassName || ''}`, [iconClassName]);

  // Handler de descarga/abrir archivo
  const handleDownload = useCallback(
    (e) => {
      e.preventDefault();
      if (!url) return;
      try {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        if (fileName) link.download = fileName;
        link.click();
      } catch (err) {
        window.open(url, '_blank');
      }
    },
    [url, fileName]
  );

  return {
    getLinkClass,
    getIconClass,
    handleDownload
  };
}
